import { useEffect, useState } from "react";
import api from "@/lib/api";
import { WhatsappLogo } from "@phosphor-icons/react";
import { card, waLink } from "./shared";
import { RateRequest } from "./RateRequest";

export function MyRequests() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/market/requests/mine").then(({ data }) => setRows(data)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  if (rows === null) return <div className="h-40 rounded-3xl bg-white/60 animate-pulse" />;

  return (
    <div className={`${card} p-5`} data-testid="my-requests">
      <p className="font-heading text-lg font-black text-sky-950 mb-2">Requests I've sent</p>
      {rows.length === 0 && <p className="text-sm text-sky-700/70">You haven't sent any requests yet.</p>}
      {rows.map((r) => (
        <div key={r.request_id} className="py-3 border-b border-sky-100 last:border-0" data-testid={`my-request-${r.request_id}`}>
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="font-semibold text-sky-950">{r.business_name}</p>
            <p className="text-xs text-sky-700/80 truncate">{r.description}</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${r.status === "accepted" ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>{r.status}</span>
            {r.business_whatsapp && (
              <a href={waLink(r.business_whatsapp)} target="_blank" rel="noreferrer" className="text-[#25D366]" data-testid={`my-request-wa-${r.request_id}`}>
                <WhatsappLogo size={22} weight="fill" />
              </a>
            )}
          </div>
        </div>
        {r.status === "accepted" && <RateRequest r={r} onRated={load} />}
        </div>
      ))}
    </div>
  );
}
